import { Grid2 as Grid, styled } from '@mui/material';

const StyledDivRoot = styled(Grid)({ padding: '1rem' });

const StyledGrid = styled(Grid)({ padding: '5px' });

const SpacedContainer = styled(Grid)({ padding: '1rem' });

const StyledTypography = styled('h3')({});

export { StyledDivRoot, StyledTypography, SpacedContainer, StyledGrid };
